module.exports = __webpack_public_path__ + "img/20210906-1630913604764030.9242eb84.png";